import { trustBadges } from "@/mocks/homeData";

export default function TrustBar() {
  return (
    <section id="vantagens" className="relative bg-background-100 border-y border-background-200/60 py-4 md:py-6 scroll-mt-16">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {trustBadges.map((badge, index) => (
            <div
              key={badge.id}
              className={`reveal reveal-delay-${index + 1} flex items-center gap-2.5 md:gap-4 justify-center`}
            >
              <div className="w-9 h-9 md:w-11 md:h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0 transition-transform duration-300 hover:scale-110">
                <i className={`${badge.icon} text-primary-600 text-base md:text-xl`} />
              </div>
              <div className="text-left min-w-0">
                <p className="text-xs md:text-sm font-bold text-foreground-900 leading-snug">
                  {badge.title}
                </p>
                <p className="text-[10px] md:text-xs text-foreground-500 leading-snug">
                  {badge.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}